export const scenarioCardWidthClassName = "w-72 shrink-0";
